import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initNativeShell } from "./lib/native";
import { initClientPerf } from "./lib/perf";
import { initOutbox } from "./lib/outbox";
import { initListingComposer } from "./lib/listingComposer";

const stripeKeyPrefix = (import.meta.env.VITE_STRIPE_PUBLIC_KEY ?? "").slice(0, 8);
console.log(`[stoop] startup stripe=${stripeKeyPrefix || "unset"}`);

// The app resets every new page to the top itself (see App.tsx). Left on "auto",
// the browser ALSO restores the previous document offset on a back navigation,
// and it does that after our effect has run — so returning from a product to the
// browse pager re-applied the detail page's offset and slid the header up under
// the status bar. Ours is the only scroll restoration we want.
if (typeof history !== "undefined" && "scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

void initNativeShell();
initClientPerf();
initOutbox();
initListingComposer();

// Offline shell. Production only — in dev it would sit in front of Vite's HMR.
// updateViaCache: "none" so the worker script itself is always revalidated;
// a stuck worker would be very hard to replace.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .catch((err) => console.warn("[stoop] sw registration failed", err));
  });
}

createRoot(document.getElementById("root")!).render(<App />);
